import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import { CardSection } from 'components/earn/styled'
import Modal from 'components/Modal'
import { RowBetween } from 'components/Row'
import React from 'react'
import styled from 'styled-components'
import { TYPE } from 'theme'

const TermsWrapper = styled.div`
  max-height: 400px;
  overflow: auto;
  padding: 16px;
  background: ${({ theme }) => theme.bg1};
  border-radius: 14px;
  color: ${({ theme }) => theme.text2};
  line-height: 18px;
  font-size: 14px;
  b {
    color: ${({ theme }) => theme.primary1};
  }

  .subtitle {
    font-size: 18px;
    font-weight: 700;
  }
`

const DisclaimerModal = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  // Check if the user has already accepted the disclaimer
  React.useEffect(() => {
    const hasAccepted = localStorage.getItem('hasAcceptedDisclaimer')
    if (!hasAccepted) {
      setIsOpen(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem('hasAcceptedDisclaimer', 'true') // Save the acceptance in localStorage
    window.dispatchEvent(new Event('storage'))
    setIsOpen(false) // Close the modal
  }

  return (
    <Modal isOpen={isOpen} onDismiss={() => console.log('Try Dismiss Disclaimer')}>
      <AutoColumn>
        <CardSection gap="md">
          <RowBetween>
            <TYPE.white fontWeight={700} fontSize={20}>
              Disclaimer
            </TYPE.white>
          </RowBetween>
          <TermsWrapper>
            <RowBetween>
              <b style={{ fontSize: '20px', lineHeight: '20px' }}>Understand the Risks Before Proceeding</b>
            </RowBetween>
            <p>
              By using <b>HyperSwap Exchange</b>, you acknowledge and agree to the following: <br />
              <br />
              <b>1. Risk of Loss: </b> Interacting with HyperSwap Exchange involves decentralized finance (DeFi), which
              carries inherent risks, including the potential loss of funds. Market volatility, smart contract
              vulnerabilities, or unintended interactions could result in financial losses. Use this platform at your
              own discretion and risk.
              <br />
              <br />
              <b>2. Self-Custody: </b> As a decentralized exchange, HyperSwap Exchange does not hold custody of your
              funds. You are solely responsible for managing your private keys, wallet access, and transactions. We
              cannot recover funds in case of errors, loss of private keys, or malicious activity.
              <br />
              <br />
              <b>3. No Guarantees: </b>
              HyperSwap Exchange is provided “as is,” without warranties or guarantees of any kind. We do not guarantee
              returns, profitability, or the security of the platform’s smart contracts.
              <br />
              <br />
              <b>4. Decentralized Nature: </b>
              Transactions on HyperSwap Exchange occur on decentralized networks and are irreversible. They may be
              affected by network conditions or unforeseen technical issues. Ensure you fully understand the financial
              and technical implications before using the platform.
            </p>
            <RowBetween>
              <b style={{ fontSize: '20px', lineHeight: '20px' }}>User Responsibility</b>
            </RowBetween>
            <p style={{ marginBottom: '0' }}>
              By clicking “I Agree,” you confirm that you:
              <br />
              <br />• Fully understand the risks associated with using HyperSwap Exchange.
              <br />
              <br />• Take full responsibility for your actions and their consequences.
              <br />
              <br />• Acknowledge that HyperSwap Exchange is not liable for any financial or other losses incurred.{' '}
              <br /> <br />
              If you do not agree with these terms, you should not use HyperSwap Exchange.
            </p>
          </TermsWrapper>
          <RowBetween>
            <ButtonPrimary onClick={handleAccept}>I Agree</ButtonPrimary>
          </RowBetween>
        </CardSection>
      </AutoColumn>
    </Modal>
  )
}
export default DisclaimerModal
